import { ArticleObject } from "@/@types/activities.ts";
import TruncateableContent from "@/components/activitystreams/activity/TruncateableContent.tsx";

export default function ActivityArticle({
  title,
  teaser,
  body,
  blog_id,
  blog_slug,
  article_id,
  article_slug,
}: ArticleObject) {
  const blogRef = blog_slug || blog_id;
  const articleRef = article_slug || article_id;
  return (
    <div className="mb-4 prose">
      <h1 className="font-bold text-2xl">{title}</h1>
      <h3>{teaser}</h3>
      <div className="mb-4">
        <TruncateableContent content={body} showMoreButton={false} />
      </div>
      <a href={`/blogs/${blogRef}/articles/${articleRef}`}>
        {I18n.t("js.activitystreams.activity.article.show_article")}
      </a>
    </div>
  );
}
